import { Contracts } from "@dreamhub/designsystem/icons";
import {
  DealConfidenceLevel,
  CsmRenewalConfidenceLevel
} from "@/pages/deals/types";
import React from "react";
import ScoreBars, { ScoreStrength } from "@/components/controls/ScoreBars";
import { dealConfidenceLevelEnumToString } from "@/pages/deals/helpers";
import IconContainer from "@/components/ui/icon-container";
import { toLower } from "lodash";

type Props = {
  value: DealConfidenceLevel | CsmRenewalConfidenceLevel;
};

const ConfidenceLevelIcon: React.FC<Props> = ({ value }) =>
  value === DealConfidenceLevel.COMMITTED ? (
    <IconContainer size="sm">
      <Contracts />
    </IconContainer>
  ) : (
    <ScoreBars
      score={toLower(dealConfidenceLevelEnumToString(value)) as ScoreStrength}
    />
  );

export default ConfidenceLevelIcon;
